/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { saveQuickEdit } from './builder';

export const defaultState = {
  editedId: null,
  colIndex: null,
  autocomplete: {}, // Address autocompletion quota
  showEditbar: false,
  isEditbarOpen: false,
  activeEditFieldId: '',
  activeMobileFieldId: '',
  showProductModal: false, // Inventory field products
};

const fieldEditSlice = createSlice({
  name: 'fieldEdit',
  initialState: defaultState,
  reducers: {
    updateEditBarStatus: (state) => {
      state.isEditbarOpen = false;
    },
    autocompleteQuotaStatus: (state, { payload }) => {
      state.autocomplete = { ...payload };
    },
    doShowEditbar: (state, { payload }) => {
      return {
        ...state,
        showEditbar: true,
        ...payload,
        colIndex: null,
        isEditbarOpen: true,
      };
    },
    doHideEditbar: (state) => {
      return {
        ...state,
        control: null,
        colIndex: null,
        editedId: null,
        showEditbar: false,
        isEditbarOpen: false,
      };
    },
    editTableCol: (state, { payload }) => {
      return {
        ...state,
        showEditbar: true,
        ...payload,
      };
    },
    showProductsModal: (state, { payload }) => {
      return {
        ...state,
        isEditbarOpen: false,
        showEditbar: false,
        editedId: null,
        control: null,
        ...payload,
      };
    },
    quickEdit: (state, { payload }) => {
      state.activeEditFieldId = payload;
    },
    doSetActiveMobileField: (state, { payload }) => {
      state.activeMobileFieldId = payload;
    },
  },
});

const { reducer } = fieldEditSlice;
export default reducer;

const {
  quickEdit,
  editTableCol,
  doShowEditbar,
  doHideEditbar,
  showProductsModal,
  updateEditBarStatus,
  doSetActiveMobileField,
  autocompleteQuotaStatus,
} = fieldEditSlice.actions;

const doSaveQuickEdit = (activeEditField, fieldProp, value, key) => (dispatch, getState) => {
  const { activePage: page } = getState().builder.present;
  dispatch(saveQuickEdit({ activeEditField, fieldProp, value, page, key }));
};

export {
  quickEdit,
  editTableCol,
  doShowEditbar,
  doHideEditbar,
  doSaveQuickEdit,
  showProductsModal,
  updateEditBarStatus,
  doSetActiveMobileField,
  autocompleteQuotaStatus,
};
